import { useMemo } from 'react';
import { useAppSelector } from '@/app/hooks';
import { selectPublicSettings } from '@/features/publicSettings/publicSettingsSlice';

export const useSubUserManagement = () => {
  const { authUserSettings } = useAppSelector(selectPublicSettings);
  const rule = authUserSettings?.subUserManagementRule;

  return useMemo(
    () => ({
      clientManagesSubUsers: rule?.clientManagesSubUsers ?? false,
      clientManagesMainUsers: rule?.clientManagesMainUsers ?? false,
      subUserCanAccessAllTransactions: rule?.subUserCanAccessAllTransactions ?? false,
      restrictSubUsersToCorporateOnly: rule?.restrictSubUsersToCorporateOnly ?? false,
    }),
    [rule]
  );
};
